import { Auth } from '@lyra/web/constants/auth'
import { createAuthenticationAdapter } from '@rainbow-me/rainbowkit'
import { createSiweMessage } from 'viem/siwe'

import { EMITTER_EVENTS, eventEmitter } from './eventEmitter'

export const authenticationAdapter = createAuthenticationAdapter({
  getNonce: async () => {
    const response = await fetch('/api/auth/nonce')
    const data: { nonce: string } = await response.json()
    return new Promise((resolve) => resolve(data.nonce))
  },
  createMessage: ({ nonce, address, chainId }) => {
    return createSiweMessage({
      domain: window.location.host,
      address,
      statement: 'Sign in to Derive',
      uri: window.location.origin,
      version: '1',
      chainId,
      nonce,
    })
  },
  verify: async ({ message, signature }) => {
    const response = await fetch('/api/auth/verify', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message, signature }),
    })

    if (!response.ok) {
      throw new Error('Failed to verify signature')
    }

    const { auth } = (await response.json()) as { auth: Auth; jwt: string }

    eventEmitter.emit(EMITTER_EVENTS.SIGN_IN, auth)

    return true
  },
  signOut: async () => {
    // we don't sign out when wallet disconnects or changes, because we want to keep the session alive
  },
})
